<app-details-loader [Height]="'70vh'" [LoaderMarginTop]="'19%'" *ngIf="loadFlag"></app-details-loader>

<ng-container *ngIf="!loadFlag">
  <payarc-page-header [title]="paymentObj.id">
    <ng-container *ngIf="payment2['data']">
      <button *ngIf="paymentObj.status === 'failed_by_gateway'" type="button" payarcButton="secondary" (click)="retryTransaction()">Retry Transaction</button>
      <button *ngIf="paymentObj.captured === 1 && (paymentObj.status === 'settled' || paymentObj.status === 'partially_settled' || paymentObj.status === 'partial_refund') && (paymentObj.amount !== paymentObj.amount_refunded) && can_refund"
              type="button" payarcButton="secondary" (click)="onRefund()">Refund</button>
      <button type="button" payarcButton="primary" (click)="viewAchPDF(paymentObj.id)">Export ACH PDF</button>
    </ng-container>
  </payarc-page-header>

  <payarc-section-card heading="ACH Transaction Details" [sub]="paymentObj.status ? (paymentObj.status | camalizeStr : true) : ''">
    <div class="pad-2col">
      <payarc-detail-card [flat]="true" [rows]="detailLeftRows"></payarc-detail-card>
      <div>
        <payarc-detail-card [flat]="true" [rows]="detailRightRows"></payarc-detail-card>
        <div class="pad-desc">
          <span class="pad-desc__label">Description</span>
          <span *ngIf="!editDescriptionFlag" class="pad-desc__value">{{ paymentObj.charge_description || '--' }}</span>
          <textarea *ngIf="editDescriptionFlag" class="pa-input" [(ngModel)]="paymentObj.charge_description" maxlength="190" rows="2"></textarea>
          <button *ngIf="!editDescriptionFlag && update_permission" type="button" payarcButton="secondary"
                  (click)="editDescriptionFlag = true; defaultDescription = paymentObj.charge_description">Edit</button>
          <ng-container *ngIf="editDescriptionFlag">
            <button type="button" payarcButton="primary" (click)="updateDescription()">Save</button>
            <button type="button" payarcButton="secondary" (click)="editDescriptionFlag = false; paymentObj.charge_description = defaultDescription">Cancel</button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="pad-error" *ngIf="errorMsg">{{ errorMsg }}</div>
  </payarc-section-card>

  <payarc-section-card heading="Bank Account">
    <payarc-detail-card [flat]="true" [rows]="bankAccountRows"></payarc-detail-card>
  </payarc-section-card>

  <payarc-section-card heading="Customer" *ngIf="paymentObj.bank_account?.data?.['customer_id']">
    <div class="pad-connections">
      <span class="pad-connections__label">Customer ID:</span>
      <a class="pad-connections__link" (click)="redirectToCustomer(paymentObj.bank_account.data['customer_id'])">{{ paymentObj.bank_account.data['customer_id'] }}</a>
    </div>
  </payarc-section-card>

  <payarc-section-card [heading]="returnsSectionTitle" *ngIf="returns_include?.data?.length > 0">
    <payarc-detail-card [flat]="true" [rows]="returnsRows"></payarc-detail-card>
  </payarc-section-card>

  <payarc-section-card heading="Transaction Metadata" *ngIf="transaction_metadata?.data?.length">
    <payarc-detail-card [flat]="true" [rows]="transactionMetadataRows"></payarc-detail-card>
  </payarc-section-card>

  <payarc-section-card heading="Extra Metadata" *ngIf="extra_metadata?.data?.length">
    <dl class="pad-metadata">
      <ng-container *ngFor="let item of extra_metadata?.data">
        <dt>{{ item.key | MetadataKeyPipe }}</dt>
        <dd *ngIf="item.key !== 'extra_signature'">{{ item.value }}</dd>
        <dd *ngIf="item.key === 'extra_signature'"><img [src]="item.signature" alt="Signature"></dd>
      </ng-container>
    </dl>
  </payarc-section-card>

  <payarc-section-card heading="Events">
    <app-event [url]="eventListUrl" [ComponentId]="paymentObj.id" [ComponentIdKey]="'charge_id'"></app-event>
  </payarc-section-card>
</ng-container>
